<template>
  <v-card class="pa-0" elevation="0">
    <v-card-text class="px-6 py-6">
      <div class="py-16 text-center" v-if="loading !== ''">
        <br><br><br>
        <v-progress-circular color="primary" indeterminate size="25"></v-progress-circular>
        <div class="mx-auto mt-10 text-h6" style="max-width: 300px">
          {{ loading }}
        </div>
        <br><br><br>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { jsonToBase64 } from "@/lib/utils";

export default {
  name: "EligibilityWidget",
  data() {
    return {
      loading: '',
      request: this.$store.state.request,
      merchant: this.$store.state.merchant,
      cc: null,
      view: ''
    }
  },
  created() {
    this.launchDataCollectionWidget();
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
    if (this.iframe) this.iframe.remove();
  },
  methods: {
    async handleMessage(e) {
      if (!e.data || !e.data.id) return;
      if (e.data.id === 'cclan-frame-loaded') this.loading = '';
      if (e.data.id === 'cclan-request') {
        this.iframe.remove();
        const { request_id, user_id } = e.data.data;
        this.loading = 'Saving..';
        await Promise.all([
          this.updateSchedule(request_id, user_id),
        ]);
        this.loading = '';
        this.$emit('done');
      }
      if (e.data.id === 'cclan-cancel') {
        this.loading = '';
        this.$emit('cancel');
        this.iframe.remove();
        await this.$store.dispatch('request/load', this.request.id);
      }
    },
    async getGlobalSetting() {
      try {
        const res = await this.$http.post('https://mobile.creditclan.com/api/v3/bnpl/global/settings', {}, {
          headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' }
        });
        return res.data.response ?? {};
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async getLenderSetting({ ecosystem, amount, lender_id }) {
      try {
        const res = await this.$http.post('https://mobile.creditclan.com/api/v3/bnpl/data_needs', {
          ecosystem, amount, lender_id: lender_id || '40425'
        }, {
          headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' }
        });
        return res.data.response ?? {};
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async launchDataCollectionWidget() {
      const { customer, request, merchant } = this.$store.state;
      const global_settings = await this.getGlobalSetting();
      const lender_settings = await this.getLenderSetting({
        ecosystem: 'shop', amount: request.total_credit, lender_id: null
      });
      const { lender_id, lender_name, image } = global_settings?.funding_partner ?? {};
      const lender = { id: lender_id, name: lender_name, image };
      const data = {
        banner: 'https://merchants.creditclan.com/assets/images/man-smiling.jpeg',
        request: {
          amount: request.total_credit,
          tenor: request.no_of_months,
        },
        profile: {
          full_name: customer.personal.full_name,
          email: customer.personal.email,
          phone: customer.personal.phone,
          date_of_birth: customer.personal.date_of_birth,
          profile_image: '',
        },
        home_address: {
          address: customer.personal.address,
          state_id: customer.personal.state,
          lga_id: customer.personal.lga
        },
        stage: request.stage,
        request_id: request.creditclan_request_id,
        lender: request.lender || lender,
        config: {
          no_frequently_called_numbers: lender_settings?.run_freq_called ? 2 : 0,
          analyze_bank_statement: lender_settings?.run_bankstatement ?? true,
          tokenize_card: true,
          show_offers: true,
          show_bank_account: true,
          show_questions: lender_settings.run_questions ?? true,
          match_account_with_bvn: global_settings?.validate_bvn ?? true,
          show_work_information: true,
          platform: 'shop-merchant',
          show_nin: lender_settings?.run_identity ?? true,
          show_signature: true
        },
        extra: {
          merchant_id: merchant.id,
          merchant_request_id: request.id,
        },
        email_verified: this.$store.getters['request/emailVerified']
      };
      const token = jsonToBase64(data);
      const url = `https://eligibility-widget.netlify.app/?token=${ token }`;
      this.loading = `Connecting with ${ data.lender.name }..`;
      this.launchIframe(url);
    },
    launchIframe(url) {
      const iframe = document.createElement('IFRAME');
      iframe.setAttribute('src', url);
      iframe.setAttribute('allow', 'geolocation');
      const style = {
        'z-index': '999999',
        overflow: 'hidden',
        margin: 0,
        padding: 0,
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100vh',
      };
      Object.assign(iframe.style, style);
      this.iframe = iframe;
      document.body.append(iframe);
    },
    async updateWidgetStage(stage) {
      const res = await this.$http.patch('https://sellbackend.creditclan.com/merchantclan/public/index.php/api/stages', {
        creditclan_request_id: this.$store.state.request.creditclan_request_id, stage
      });
      if (res.data.status) this.$store.commit('request/set', { stage });
    },
    async saveOffer(offer) {
      await this.$http.post('https://sellbackend.creditclan.com/merchantclan/public/index.php/api/offer', {
        request_id: this.$store.state.request.id, offer
      });
      this.$store.commit('request/set', { offer });
    },
    async updateSchedule(request_id, user_id) {
      const res = await this.$http.post('https://mobile.creditclan.com/api/v3/loan/merchant/schedule', {
        request_id, user_id
      }, {
        headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' }
      });
      const request_schedule = res.data.data;
      const payload = request_schedule.map((item, i) => ({
        date: item.repayment_date,
        serial: i + 1,
        amount: item.term_repayment
      }));
      await this.$http.put(`https://sellbackend.creditclan.com/merchantclanbackend/public/index.php/api/request_schedule/${ this.request.id }`, { payload });
      this.$store.commit('request/set', { request_schedule: payload });
    },
    async addToCompleted(value) {
      const id = this.request.id;
      const analysis_completed = [...this.request.analysis_completed];
      analysis_completed.push(value);
      await this.$http.patch(`https://sellbackend.creditclan.com/merchantclan/public/index.php/api/stages/${ id }`, {
        analysis_completed, type: 'customer'
      });
      this.$store.commit('request/set', { analysis_completed });
    }
  },
}
</script>
